/// <reference path="../../../Scripts/TypeScript/angularjs/angular.d.ts"/>
/// <reference path="../../../Scripts/TypeScript/umbrella/umbrella.d.ts"/>

namespace Umbrella.CustomerService.UnitCard.Valuation {
    @Service('CustomerService', 'UnitValuationJitService')
    @Inject('UnitCardStore', 'UnitValuationHub', 'UnitCardService', 'ToastMessageService')
    export class UnitValuationJitService {
        private message: any;

        constructor(
            store: UnitCardStore,
            private unitValuationHub: IUnitValuationHubProxy,
            private unitCardService: UnitCardService,
            private toastMessageService: ToastMessageService
        ) {
            const selectUnitId = (state: UnitCardState) => state && state.id;

            unitValuationHubOnUpdated$
                .filter(unitId => {
                    return selectUnitId(store.getState()) === unitId;
                })
                .subscribe(unitId => {
                    if (store.getState().valuation) this.unitCardService.loadValuations(true);

                    this.clearToastMessage();
                });

            unitValuationHubOnJitStarted$
                .filter(unitId => {
                    return selectUnitId(store.getState()) === unitId;
                })
                .subscribe(model => {
                    this.clearToastMessage();
                    this.message = this.toastMessageService.updating('Woningwaardering', 60000);
                });

            store.state$
                .map(selectUnitId)
                .distinctUntilChanged()
                .flatMapLatest(Modules.waitUntilSignalRConnected)
                .debounce(() => Rx.Observable.timer(1000))
                .subscribe(unitId => this.triggerJitUpdate(unitId));

            store.event$.where(e => e.type === 'UnitCardUnloadedEvent').subscribe(_ => this.clearToastMessage());
        }

        private clearToastMessage() {
            if (this.message) {
                this.toastMessageService.clear(this.message);
                this.message = null;
            }
        }

        private triggerJitUpdate(unitId: System.Guid) {
            this.clearToastMessage();

            if (unitId)
                this.unitValuationHub.server.startJitUpdate(unitId).fail(e => {
                    this.clearToastMessage();
                    this.message = this.toastMessageService.error('Synchronisatie woningwaardering mislukt');
                });
        }
    }
}
